import { render } from "./SelectInstance.vue?vue&type=template&id=b057a1d0"
import script from "./SelectInstance.vue?vue&type=script&lang=js"
export * from "./SelectInstance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__